/* Size guide. Делегирование на document — Dawn перерисовывает блок товара
   при смене варианта, обработчики на самих кнопках после этого отваливаются. */
(function () {
  'use strict';

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  document.addEventListener('click', function (event) {
    var t = event.target;

    var opener = closest(t, '[data-sg-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-sg-open'));
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      return;
    }

    if (closest(t, '[data-sg-close]')) {
      var open = closest(t, 'dialog');
      if (!open) return;
      if (typeof open.close === 'function') {
        open.close();
      } else {
        open.removeAttribute('open');
      }
      return;
    }

    // клик по подложке: цель — сам <dialog>, содержимое лежит в .sg-sheet
    if (t.tagName === 'DIALOG' && t.classList.contains('sg-dialog')) {
      if (typeof t.close === 'function') t.close();
      return;
    }

    var unit = closest(t, '[data-sg-unit]');
    if (unit) {
      var sgU = closest(unit, '.sg');
      if (!sgU) return;
      sgU.setAttribute('data-unit', unit.getAttribute('data-sg-unit'));
      Array.prototype.forEach.call(sgU.querySelectorAll('[data-sg-unit]'), function (b) {
        b.classList.toggle('is-on', b === unit);
      });
      return;
    }

    var tab = closest(t, '[data-sg-tab]');
    if (tab) {
      var sgT = closest(tab, '.sg');
      if (!sgT) return;
      var idx = tab.getAttribute('data-sg-tab');
      Array.prototype.forEach.call(sgT.querySelectorAll('[data-sg-tab]'), function (b) {
        b.setAttribute('aria-selected', b === tab ? 'true' : 'false');
      });
      Array.prototype.forEach.call(sgT.querySelectorAll('[data-sg-pane]'), function (p) {
        p.hidden = p.getAttribute('data-sg-pane') !== idx;
      });
    }
  });
})();
